import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Icon } from '../../atoms';
import { Button } from '../Button';

const StyledButton = styled(Button)`
  padding: 0;
  height: 24px;
  width: 24px;
  border-radius: 6px;
`;

const PromptSubmitButton = ({ disabled = false, className = null, onClick = null }) => (
  <StyledButton disabled={disabled} small type='submit' className={className} onClick={onClick}>
    <Icon name='arrow-up' color='var(--white)' size={24} />
  </StyledButton>
);

PromptSubmitButton.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export { PromptSubmitButton };
